import { defineStore } from 'pinia';
import useSettingsStore from '~/stores/settings';
import { getGameName } from '@/common/js/gameAbout';

export const useAmountMemoryStore = defineStore('amountMemory', {
    state: () => ({
        lastAmountMap: {} as any,
    }),
    actions: {
        setLastAmount(amount: any) {
            if (import.meta.server) return;
            const settingStore = useSettingsStore();
            const coinName = settingStore.pickedCurrency;
            // const name = window.location.href.split('/').pop();
            const name = getGameName();

            // Ensure the object exists
            if (!this.lastAmountMap[name]) {
                this.lastAmountMap[name] = {};
            }

            this.lastAmountMap[name][coinName] = Number(amount);
            //  localStorage.setItem(AMOUNT_KEY, JSON.stringify(this.lastAmountMap));
        },
        setCircleLastAmount(amount: any, index: string) {
            if (import.meta.server) return;
            const settingStore = useSettingsStore();
            const coinName = settingStore.pickedCurrency!;
            // const pageKey = window.location.href.split('/').pop()!;
            const pageKey = getGameName();

            // ensure top-level is an object
            if (
                !this.lastAmountMap[pageKey] ||
                typeof this.lastAmountMap[pageKey] !== 'object'
            ) {
                this.lastAmountMap[pageKey] = {};
            }

            // ensure coinName slot is an object (not a leftover number)
            if (
                !this.lastAmountMap[pageKey][coinName] ||
                typeof this.lastAmountMap[pageKey][coinName] !== 'object'
            ) {
                this.lastAmountMap[pageKey][coinName] = {};
            }

            // now it's safe to assign by index
            this.lastAmountMap[pageKey][coinName][index] = Number(amount);
            console.log(this.lastAmountMap[pageKey][coinName][index]);
        },          
        getCircleLastAmount(index: number) {
            if (import.meta.server) return;
            const settingStore = useSettingsStore();
            const coinName = settingStore.pickedCurrency;
            // const name = window.location.href.split('/').pop();
            const name = getGameName();
            if (!this.lastAmountMap[name]) {
                return 0;
            }
            if (!this.lastAmountMap[name][coinName]) {
                return 0;
            }
            return this.lastAmountMap[name][coinName][index] || 0;
        },

        getLastAmount() {
            if (import.meta.server) return;
            const settingStore = useSettingsStore();
            const coinName = settingStore.pickedCurrency;
            // const name = window.location.href.split('/').pop();
            const name = getGameName();
            if (!this.lastAmountMap[name]) {
                return 0;
            }
            if (!this.lastAmountMap[name][coinName]) {
                return 0;
            }
            return this.lastAmountMap[name][coinName] || 0;
        },
    },
    getters: {
        gameAmounts: (state) => {
            const settingStore = useSettingsStore();
            const coinName = settingStore.pickedCurrency;
            return Object.keys(state.lastAmountMap).map((name) => ({
                name: name,
                lastAmount: state.lastAmountMap[name][coinName],
            }));
        },
        getCurrentGameName() {
            if (import.meta.server) return;
            // return window.location.href.split('/').pop();
            return getGameName();
        },
        currentGameAmount(state) {
            if (import.meta.server) return;
            // const name = window.location.href.split('/').pop();
            const name = getGameName();
            if (!state.lastAmountMap[name]) {
                return 0;
            }
            const settingStore = useSettingsStore();
            const coinName = settingStore.pickedCurrency;

            if (!state.lastAmountMap[name]?.[coinName]) {
                return 0;
            }
            return state.lastAmountMap[name][coinName] || 0;
        },
    },
    persist: {
        storage: persistedState.localStorage,
    },
});
